import React from "react";
import { Container, Col, Row, Form, Button } from "react-bootstrap";


function Profile() {
  return (
    <div>
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} lg={8} className="rgc-request p-4 rgc-profile ">
            <div className="d-flex rgc-title">
              <div className="rgc-title-point"></div>
              <h4>پروفایل <span>کاربر</span></h4>
            </div>
            <Form>
              <Form.Group className="mb-3" controlId="formBasicName">
                <Form.Label>نام و نام خانوادگی</Form.Label>
                <Form.Control type="text"   autoComplete="off" placeholder="نام و نام خانوادگی" />
                {/* <Form.Text className="text-muted">
                  We'll never share your email with anyone else.
                </Form.Text> */}
              </Form.Group>

              <Form.Group className="mb-3" controlId="formBasicNumber">
                <Form.Label>شماره همراه</Form.Label>
                <Form.Control type="number"   autoComplete="off" placeholder="شماره همراه" />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formBasicCode">
                <Form.Label>کد ملی</Form.Label>
                <Form.Control type="number"   autoComplete="off" placeholder="کد ملی" />
              </Form.Group>
            </Form>
          </Col>
          <Col xs={12} className="text-center">
            <Button className="rgc-orderreg-btn rgc-order-btn-sub" >
              ارسال
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Profile;
